'use client';
import { createProps, createSplitProps } from '@chakra-ui/utils';

const focusLockProps = createProps()([
  "initialFocusRef",
  "finalFocusRef",
  "contentRef",
  "restoreFocus",
  "isDisabled",
  "autoFocus",
  "persistentFocus",
  "lockFocusAcrossFrames"
]);
const splitFocusLockProps = createSplitProps(focusLockProps);

export { splitFocusLockProps };
